
export class Declarations {
  
  public static EUR: any[] = [
    {
      'Amount': 100,
      'Currency': '€',
      'Type': 'coin',
      'Image': 'eur-1.png'
    },
    {
      'Amount': 200,
      'Currency': '€',
      'Type': 'coin',
      'Image': 'eur-2.png'
    },
    {
      'Amount': 500,
      'Currency': '€',
      'Type': 'banknote',
      'Image': 'eur-5.png'
    },
    {
      'Amount': 1000,
      'Currency': '€',
      'Type': 'banknote',
      'Image': 'eur-10.png'
    },
    {
      'Amount': 2000,
      'Currency': '€',
      'Type': 'banknote',
      'Image': 'eur-20.png'
    },
    {
      'Amount': 5000,
      'Currency': '€',
      'Type': 'banknote',
      'Image': 'eur-50.png'
    },
    {
      'Amount': 10000,
      'Currency': '€',
      'Type': 'banknote',
      'Image': 'eur-100.png'
    }
  ];
  
  public static ZAR: any[] = [
    {
      "Amount": 1000,
      "Currency":"$",
      "Type":"banknote",
      "Image": "rand-10.png"
    },
    {
      "Amount": 2000,
      "Currency":"$",
      "Type":"banknote",
      "Image": "rand-20.png"
    },
    {
      "Amount": 5000,
      "Currency":"$",
      "Type":"banknote",
      "Image": "rand-50.png"
    },
    {
      "Amount": 10000,
      "Currency":"$",
      "Type":"banknote",
      "Image": "rand-100.png"
    },
    { 
      "Amount": 20000,
      "Currency": "$",
      "Type": "banknote",
      "Image":"rand-200.png"
    }
  ];
}
